import React, { Component } from 'react'
import PropTypes from 'prop-types'

import cx from 'classnames'
import { FormattedMessage } from 'react-intl'

import acl from '../../../../services/acl'
import hocDialog from '../../../../services/dialog/hocDialog'

import hocConnect from './hocConnect'

import { TYPES, LOCALE_PREFIX } from './constants'

import './style.scss'

@acl
@hocDialog
@hocConnect
export default class Banner extends Component {
    static propTypes = {
        first: PropTypes.bool,
        hasRights: PropTypes.func.isRequired,
        listType: PropTypes.string,
        openDialog: PropTypes.func.isRequired,
        openLinkagesById: PropTypes.func.isRequired,
        subjectId: PropTypes.number.isRequired,
    }

    static defaultProps = {
        listType: TYPES.CHILDS,
    }

    handleOpenLinkages = () => {
        const { openLinkagesById, hasRights, openDialog, subjectId } = this.props
        if (hasRights('linkages')) {
            openLinkagesById(subjectId)
        } else {
            openDialog('reportOwnershipConfirm')
        }
    }

    render() {
        const { listType, first } = this.props
        const { PARENTS, CHILDS } = TYPES

        return (
            <div className={cx('ownership-banner', { parents: listType === PARENTS && !first })}>
                {listType === CHILDS && (
                    <div className={'banner-navigation'}>
                        {' '}
                        <div className={'arrow-right'} />{' '}
                    </div>
                )}
                {listType === PARENTS && (
                    <div className={'banner-navigation parents'}>
                        {' '}
                        <div className={'arrow-right'} />{' '}
                    </div>
                )}
                <div className={'ownership-banner-content'}>
                    <div className={'ownership-banner-icon'} />
                    <div className={'ownership-banner-text'}>
                        <FormattedMessage id={`${LOCALE_PREFIX}.smallBannerText`} />
                        <span className={'ownership-banner-distraints'} onClick={this.handleOpenLinkages}>
                            <FormattedMessage id={`${LOCALE_PREFIX}.smallBannerLink`} />
                        </span>
                    </div>
                </div>
            </div>
        )
    }
}
